<template>
  <div class="m-info">
    <div class="info-top">
      <div class="top-div">
        <img class="header-img" :src="formData.avatarName || headerImg" alt />
        <div>{{formData.realName || formData.nickName}}</div>
        <img class="vip-img" :src="vipImg" alt />
      </div>
    </div>
    <div class="user-info">
      <div class="info-t">身份信息</div>
      <img :src="realName" alt />
    </div>
    <van-form>
      <van-field
        input-align="center"
        v-model="formData.username"
        label="姓名"
        placeholder="姓名"
      />
      <van-field
        input-align="center"
        v-model="formData.phone"
        label="电话"
        placeholder="电话"
      />
      <van-field
        input-align="center"
        v-model="formData.jobName"
        label="职位"
        placeholder="职位"
      />
      <van-field
        input-align="center"
        v-model="formData.deptName"
        label="公司"
        placeholder="公司"
      />
      <van-field
        type="textarea"
        input-align="center"
        v-model="formData.motto"
        autosize
        label="个人签名"
        placeholder="个人签名"
      />
      <van-field
        type="textarea"
        autosize
        input-align="center"
        v-model="formData.profiles"
        label="简介"
        placeholder="简介"
      />
      <van-field input-align="center" name="uploader" label="职业照">
        <template #input>
          <!-- <van-uploader v-model="uploader" /> -->
          <van-uploader
            :disabled="formData.status==1"
            :max-size="1000 * 1024"
            :after-read="afterRead"
          >
            <img style="width:50%" :src="formData.myImg" alt />
          </van-uploader>
        </template>
      </van-field>
    </van-form>
    <van-checkbox icon-size="10px" checked-color="#FC6C21" v-model="checked" shape="square">第一次注册信息保存后将进行实名认证。</van-checkbox>
    <div class="info-but">
      <img @click.prevent="goCard" src="./img/but.png" alt />
      <img @click.prevent="onSubmit" src="@/assets/publicImg/save.png" alt />
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
import { Toast } from 'vant';
export default {
  data() {
    return {
      headerImg: require('@/assets/publicImg/header.png'),
      vipImg: require('@/assets/publicImg/vip.png'),
      userName: '未来可期',
      realName: require('@/assets/publicImg/real-name.png'),//是否实名图标
      formData: {
        username: '张三',
        phone: '130000000',
        jobName: '',
        deptName: '',
        sign: '加入给你三天光明',
        synopsis: '昨天，今天，明天',
        status: 0,
        myImg: require('../../assets/img/product1.jpg'),
      },
      checked: true,
      isReal:'',//是否实名
    }
  },
  mounted() {
    this.getUser()
  },
  methods: {
    getUser() {
      let userId = localStorage.getItem('userid')
      this.$fetchGet(URL.getStaffsCard.url, { userId: userId }).then((res) => {
        this.formData = res.data.data
        this.isReal=res.data.data.isReal
        if (this.formData.status == '1') {
          Toast('个人照片审核中')
        } else if (this.formData.status == '9') {
          Toast('个人照片未通过审核')
        }
        if(this.isReal=='1'){
          this.realName=require('@/assets/publicImg/real-name1.png')
        }
        this.myImg = (!res.data.data.bodyImg ? require('./../../assets/img/mImg.png') : res.data.data.bodyImg)
        this.userId = res.data.data.userId
        this.id = res.data.data.id
      })
    },
    afterRead(file) {
      let data = new FormData();
      data.append("file", file.file);
      data.append("bucketName", 'loan');
      this.$fetchPost(URL.upImg.url, data).then((res) => {
        this.formData.myImg = res.data.data.fileUrl || require('./../../assets/img/mImg.png')
      })
    },
    onSubmit() {
      if(this.checked==false){
        Toast('请勾选第一次保存协议')
        return
      }
      let data = {
        userId: this.userId,
        id: this.id,
        oldBodyId: this.formData.bodyId,
        motto: this.formData.motto,
        profiles: this.formData.profiles,
        status: this.bodyId ? 1 : 0,
        oldBodyImg: this.myImg,
        jobName: this.formData.jobName,
        deptName: this.formData.deptName,
      }
      this.$fetchPost(URL.getStaffsCard.url, data).then((res) => {
        if (res?.data?.code == 20000) {
          this.myImg = res.data.data.bodyImg
          this.getUser()
          if(this.isReal!='1'){
            this.$router.push('/identityCheck')
          }
          Toast(res.data.msg)
        }
      })
    },
    //生成名片
    goCard(){
      this.$router.push('/businessCard')
    }
  }
}
</script>

<style lang="less" scoped>
.m-info {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  font-weight: 500;
  .info-top {
    width: 375px;
    height: 133px;
    background: url("./img/bg.png") no-repeat 50%;
    background-size: 100% 100%;
    .top-div {
      text-align: center;
      font-size: 14px;
      color: #333333;
      .header-img {
        width: 60px;
        height: 60px;
        margin-top: 15px;
        border-radius: 50%;
      }
      .vip-img {
        width: 62px;
        height: 15px;
        margin-top: 8px;
      }
    }
  }
  .user-info {
    display: flex;
    font-size: 14px;
    color: #333333;
    .info-t {
      margin: 20px 10px 15px 15px;
    }
    img {
      width: 35px;
      height: 12px;
      margin-top: 22px;
    }
  }
  .van-checkbox {
    margin: 15px 0 0 10px;
    font-size: 9px;
    color: #999999;
  }
  .info-but {
    display: flex;
    margin: 35px 0 40px 0;
    justify-content: center;
    img {
      width: 113px;
      height: 30px;
      &:last-child {
        margin-left: 15px;
      }
    }
  }
}
</style>